export default __webpack_public_path__ + "static/media/background-customer-portal.b5de287b.jpg";